import { createContext } from 'react';

import { DatagridContextValue } from 'react-admin';

export const DatargidWithSummaryContext = createContext<DatagridContextValue>({});

DatargidWithSummaryContext.displayName = 'DatargidWithFooterContext';
